import userClient from '../config/api/userClient';
var confluenceUrl = "confluence/";
export var getPublisherManualPages = function (params) {
    return userClient.get(confluenceUrl, { params: params });
};
export var getPublisherManualPageById = function (id, params) {
    return userClient.get(confluenceUrl + "page/" + id, { params: params });
};
